import React from 'react';

import { Card } from 'semantic-ui-react';

const AdditionalResources = () => (
  <div
    css={{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      margin: '60px 0',
    }}
  >
    <p
      css={{
        fontSize: 32,
        textAlign: 'center',
        color: '#333333',
        fontWeight: 700,
        marginBottom: 20,
      }}
    >
      Additional Resources
    </p>
    <Card
      css={{
        '&.ui.card': {
          width: 635,
          borderRadius: 10,
          margin: 'auto',
          boxShadow: '0px 1px 3px 0px #BCBDBD, 0px 0px 0px 1px #D4D4D5',
          filter: 'drop-shadow(10px 10px 50px rgba(0, 0, 0, 0.25))',
          pointer: 'cursor',

          '&:hover': {
            boxShadow: 'none',
          },
        },
      }}
      onClick={() =>
        window
          .open(
            'https://www.imda.gov.sg/imtalent/programmes/skills-framework-for-ict',
            '_blank',
          )
          .focus()
      }
    >
      <div
        css={{
          width: '100%',
          height: 250,
          background:
            "url('https://images.snaphunt.com/assets/images/job-skill.png')",
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          borderBottom: 'solid 10px #6c2d8a',

          '&::before': {
            content: '""',
            background: 'rgba(108, 45, 138, 0.4)',
            width: '100%',
            height: 250,
            position: 'absolute',
          },
        }}
      />
      <Card.Content>
        <div
          css={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <p
            css={{
              fontSize: 24,
              textAlign: 'center',
              color: '#6C2D8A',
              fontWeight: 700,
              maxWidth: 330,
            }}
          >
            Skills Framework for Infocomm Technology (ICT)
          </p>
        </div>
      </Card.Content>
    </Card>
  </div>
);

export default AdditionalResources;
